/* =========================================================
   Sports n deco — Moteur "compo FOOT" (navigateur)
   Terrain dessiné + formation + 11 maillots (numéro, couleur, nom) 100% perso.
   API : SNFoot.render(data, opts) -> string SVG
     data : { team, competition, subtitle, formation, jersey, gk, pitch:'classique'|'nuit',
              players:[{num,name}…11] }
     opts : { palette }
   ========================================================= */
(function () {
  const PW = 800, PH = 1066;

  const PALETTES = {
    blanc:   { label:'Blanc',        bg:'#ffffff', ink:'#0B2D5B', muted:'#8891a0', accent:'#FF6B2C', line:'#e6eaee' },
    mono:    { label:'Noir & blanc', bg:'#ffffff', ink:'#111111', muted:'#8a8a8a', accent:'#111111', line:'#e2e2e2' },
    nuit:    { label:'Nuit',         bg:'#0B2D5B', ink:'#ffffff', muted:'#9fb2ce', accent:'#FF6B2C', line:'#1c4577' },
    encre:   { label:'Encre',        bg:'#0E0E10', ink:'#ffffff', muted:'#8a8a90', accent:'#FF6B2C', line:'#2a2a2e' },
    kraft:   { label:'Kraft',        bg:'#efe7d6', ink:'#3A2C12', muted:'#8a7a58', accent:'#c2410c', line:'#d2c6a8' },
    sauge:   { label:'Sauge',        bg:'#e9f0eb', ink:'#24402F', muted:'#6f8a79', accent:'#2f7d54', line:'#c3d4c8' },
    ardoise: { label:'Ardoise',      bg:'#26303a', ink:'#f2f5f7', muted:'#9fb0bd', accent:'#e8b04b', line:'#3b4855' },
    bordeaux:{ label:'Bordeaux',     bg:'#f4ede7', ink:'#45131c', muted:'#9a7f70', accent:'#9c2233', line:'#dccabd' },
  };
  const PITCHES = {
    classique: { label:'Vert classique', base:'#2f8f4e', stripe:'#2b8449', line:'#ffffff' },
    nuit:      { label:'Nocturne',       base:'#17603a', stripe:'#134f30', line:'#eafff2' },
  };
  const FORMATIONS = {
    '4-4-2':[4,4,2], '4-3-3':[4,3,3], '4-2-3-1':[4,2,3,1], '3-5-2':[3,5,2], '3-4-3':[3,4,3], '4-5-1':[4,5,1], '5-3-2':[5,3,2],
  };

  const esc = s => String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  function lum(hex){ const h=String(hex).replace('#',''); if(h.length<6)return 1; const r=parseInt(h.substr(0,2),16)/255,g=parseInt(h.substr(2,2),16)/255,b=parseInt(h.substr(4,2),16)/255;
    const f=v=>v<=.03928?v/12.92:Math.pow((v+.055)/1.055,2.4); return .2126*f(r)+.7152*f(g)+.0722*f(b); }
  const contrast = hex => lum(hex) > 0.5 ? '#111111' : '#ffffff';

  function positions(formName){
    const lines = FORMATIONS[formName] || FORMATIONS['4-3-3'];
    const L = lines.length, margin = 0.12;
    const pts = [{ x:0.5, y:0.955, line:-1, n:1 }];
    const yDef = 0.82, yAtt = 0.17;
    lines.forEach((n, i) => {
      const y = L>1 ? yDef - (yDef-yAtt)*(i/(L-1)) : 0.5;
      for (let j=0;j<n;j++){ const x = n>1 ? margin + (1-2*margin)*((j+0.5)/n) : 0.5; pts.push({ x, y, line:i, n }); }
    });
    return pts;
  }

  function pitch(x, y, w, h, ps){
    const nx = a => x + a*w, ny = b => y + b*h;
    const R = 0.11*h, cx = nx(0.5), cy = ny(0.5), sw = 2.2;
    const box = (bx,by,bw,bh)=>`<rect x="${nx(bx).toFixed(1)}" y="${ny(by).toFixed(1)}" width="${(bw*w).toFixed(1)}" height="${(bh*h).toFixed(1)}" fill="none" stroke="${ps.line}" stroke-width="${sw}"/>`;
    let o = `<rect x="${x.toFixed(1)}" y="${y.toFixed(1)}" width="${w.toFixed(1)}" height="${h.toFixed(1)}" fill="${ps.base}"/>`;
    for (let i=0;i<8;i++){ if(i%2) o += `<rect x="${x.toFixed(1)}" y="${(y+h*i/8).toFixed(1)}" width="${w.toFixed(1)}" height="${(h/8).toFixed(1)}" fill="${ps.stripe}"/>`; }
    o += `<rect x="${x.toFixed(1)}" y="${y.toFixed(1)}" width="${w.toFixed(1)}" height="${h.toFixed(1)}" fill="none" stroke="${ps.line}" stroke-width="${sw}"/>`;
    o += `<line x1="${x.toFixed(1)}" y1="${cy.toFixed(1)}" x2="${(x+w).toFixed(1)}" y2="${cy.toFixed(1)}" stroke="${ps.line}" stroke-width="${sw}"/>`;
    o += `<circle cx="${cx.toFixed(1)}" cy="${cy.toFixed(1)}" r="${R.toFixed(1)}" fill="none" stroke="${ps.line}" stroke-width="${sw}"/><circle cx="${cx.toFixed(1)}" cy="${cy.toFixed(1)}" r="2.6" fill="${ps.line}"/>`;
    const bw=0.62, bd=0.16, gw=0.30, gd=0.065;
    o += box(0.5-bw/2,0,bw,bd) + box(0.5-gw/2,0,gw,gd);
    o += `<circle cx="${cx.toFixed(1)}" cy="${ny(0.105).toFixed(1)}" r="2.6" fill="${ps.line}"/>`;
    o += `<path d="M${nx(0.405).toFixed(1)} ${ny(bd).toFixed(1)} Q ${cx.toFixed(1)} ${ny(bd+0.075).toFixed(1)} ${nx(0.595).toFixed(1)} ${ny(bd).toFixed(1)}" fill="none" stroke="${ps.line}" stroke-width="${sw}"/>`;
    o += box(0.5-bw/2,1-bd,bw,bd) + box(0.5-gw/2,1-gd,gw,gd);
    o += `<circle cx="${cx.toFixed(1)}" cy="${ny(0.895).toFixed(1)}" r="2.6" fill="${ps.line}"/>`;
    o += `<path d="M${nx(0.405).toFixed(1)} ${ny(1-bd).toFixed(1)} Q ${cx.toFixed(1)} ${ny(1-bd-0.075).toFixed(1)} ${nx(0.595).toFixed(1)} ${ny(1-bd).toFixed(1)}" fill="none" stroke="${ps.line}" stroke-width="${sw}"/>`;
    return o;
  }

  function jersey(px, py, r, color, num, name, maxW){
    const u = (dx,dy)=>`${(px+dx*r).toFixed(1)} ${(py+dy*r).toFixed(1)}`;
    const d = `M${u(-0.30,-0.42)} L${u(-0.55,-0.32)} L${u(-0.95,-0.05)} L${u(-0.72,0.18)} L${u(-0.52,0.02)} L${u(-0.5,0.78)} L${u(0.5,0.78)} L${u(0.52,0.02)} L${u(0.72,0.18)} L${u(0.95,-0.05)} L${u(0.55,-0.32)} L${u(0.30,-0.42)} L${u(0,-0.26)} Z`;
    let o = `<path d="${d}" fill="${color}" stroke="rgba(0,0,0,0.28)" stroke-width="1.2" stroke-linejoin="round"/>`;
    o += `<text x="${px.toFixed(1)}" y="${(py+0.30*r).toFixed(1)}" font-size="${(0.72*r).toFixed(1)}" font-weight="800" fill="${contrast(color)}" text-anchor="middle" dominant-baseline="middle">${esc(num)}</text>`;
    const nm = (name||'').toUpperCase();
    if (nm){ let ns = 0.5*r; const est = nm.length*0.62*ns; if (est>maxW) ns = Math.max(0.28*r, maxW/(nm.length*0.62));
      o += `<text x="${px.toFixed(1)}" y="${(py+r+0.42*r).toFixed(1)}" font-size="${ns.toFixed(1)}" font-weight="700" fill="#ffffff" stroke="rgba(6,20,10,0.6)" stroke-width="${(ns*0.12).toFixed(1)}" paint-order="stroke" text-anchor="middle" letter-spacing="0.4">${esc(nm)}</text>`; }
    return o;
  }

  function render(data, opts){
    data = data || {}; opts = opts || {};
    const p = PALETTES[opts.palette] || PALETTES.nuit;
    const ps = PITCHES[data.pitch] || PITCHES.classique;
    const cx = PW/2;
    const PX = 96, PY = 210, PWi = PW - 2*PX, PHi = 720;
    const form = FORMATIONS[data.formation] ? data.formation : '4-3-3';
    const pts = positions(form);
    const maxLine = Math.max(1, ...FORMATIONS[form]);
    const r = Math.min(44, (PWi*0.82)/maxLine*0.42);
    const players = data.players || [];
    let js = '';
    pts.forEach((pt,i)=>{ const pl = players[i] || {}; const isGk = i===0;
      const maxW = (pt.n>1 ? (PWi*(1-2*0.12)/pt.n) : PWi*0.4) * 0.90;
      js += jersey(PX+pt.x*PWi, PY+pt.y*PHi, r, isGk?(data.gk||'#f4c542'):(data.jersey||'#e23636'),
        pl.num!=null&&pl.num!==''?pl.num:(i+1), pl.name||'', maxW); });

    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${PW} ${PH}" font-family="'Sora','Inter',sans-serif">
<rect width="${PW}" height="${PH}" fill="${p.bg}"/>
<rect x="18" y="18" width="${PW-36}" height="${PH-36}" fill="none" stroke="${p.line}" stroke-width="1.5" rx="3"/>
<text x="${cx}" y="112" font-size="19" font-weight="700" fill="${p.accent}" text-anchor="middle" letter-spacing="5">${esc((data.competition||'').toUpperCase())}</text>
<text x="${cx}" y="168" font-size="46" font-weight="800" fill="${p.ink}" text-anchor="middle" letter-spacing="-0.5">${esc((data.team||'VOTRE ÉQUIPE').toUpperCase())}</text>
${pitch(PX,PY,PWi,PHi,ps)}
${js}
<text x="${cx}" y="1004" font-size="24" font-weight="800" fill="${p.ink}" text-anchor="middle" letter-spacing="3">${esc(form)}</text>
${data.subtitle?`<text x="${cx}" y="1032" font-size="13" font-weight="600" fill="${p.muted}" text-anchor="middle" letter-spacing="2">${esc(data.subtitle.toUpperCase())}</text>`:''}
</svg>`;
  }

  window.SNFoot = { render, PALETTES, PITCHES, FORMATIONS, PW, PH };
})();
